import firebase from "@/firebase";
import store from "@/store";

const fetchUserIsAdmin = async () => {
  if (firebase.auth.currentUser == null) {
    store.state.auth.isAdmin = false;
    return false;
  }
  try {
    const snapshot = await firebase.firestore
      .collection("users")
      .doc(firebase.auth.currentUser.uid)
      .get();
    if (snapshot.data() == null) {
      return false;
    }
    if (snapshot.data().roles.indexOf("admin") === -1) {
      store.state.auth.isAdmin = false;
      return false;
    }
    store.state.auth.isAdmin = true;
    return true;
  } catch (e) {
    console.error(e);
    store.state.auth.isAdmin = false;
    return false;
  }
};

export default {
  fetchUserIsAdmin,
};
